<template>
    <v-textarea disabled label="Respuesta larga" outlined dense></v-textarea>
</template>

<script>
export default {
    name: 'LongAnswerQuestion',
    props: ['question']
}
</script>